var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_21568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "url(#paint0_linear_1646_21568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "url(#paint1_radial_1646_21568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "url(#paint2_radial_1646_21568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 36.6667H40.6663V16C40.6663 14.162 39.171 12.6667 37.333 12.6667H35.333V22.6667L31.333 20L27.333 22.6667V12.6667H18.6663C16.8283 12.6667 15.333 14.162 15.333 16V37.6933C16.0642 37.0328 17.0143 36.667 17.9997 36.6667Z",
    fill: "url(#paint3_linear_1646_21568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6663 43.3333H17.9997C17.2924 43.3333 16.6142 43.0524 16.1141 42.5523C15.614 42.0522 15.333 41.3739 15.333 40.6667C15.333 39.9594 15.614 39.2811 16.1141 38.781C16.6142 38.281 17.2924 38 17.9997 38H40.6663C40.6663 38 39.9997 39.1253 39.9997 40.6667C39.9997 42.208 40.6663 43.3333 40.6663 43.3333Z",
    fill: "url(#paint4_linear_1646_21568)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1646_21568",
    x1: 8.20105,
    y1: 47.799,
    x2: 47.799,
    y2: 8.20105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1646_21568",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0109 27.6842) rotate(-45) scale(44.6717 13.7743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    stopColor: "#FF9946",
    stopOpacity: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9537,
    stopColor: "#FFAE31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1646_21568",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8891 28.1109) scale(28.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    stopColor: "#FF8758",
    stopOpacity: 0.791
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4257,
    stopColor: "#FF9D42",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FFAA35",
    stopOpacity: 0.249
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FFAE31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1646_21568",
    x1: 27.9997,
    y1: 12.6667,
    x2: 27.9997,
    y2: 37.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1646_21568",
    x1: 27.9997,
    y1: 38,
    x2: 27.9997,
    y2: 43.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_21568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5cd01a5b92889b64f69df34821637571.svg";
export { ForwardRef as ReactComponent };